import { useState } from "react"
import {
    Typography,
    Button,
    Space,
    Card,
    Radio,
    Select,
    Checkbox,
    message,
    TimePicker,
} from "antd"
import {
    MailOutlined,
    MessageOutlined,
    BellOutlined,
    GlobalOutlined,
} from "@ant-design/icons"
import moment from "moment"

const { Title, Text } = Typography
const { Option } = Select

// Helper for Ant Design message
const showMessage = (type, content) => {
    message[type](content)
}

const Notifications = () => {
    const [deliveryFrequency, setDeliveryFrequency] = useState("daily")
    const [deliveryChannels, setDeliveryChannels] = useState(["email", "in-app"])
    const [severityFilter, setSeverityFilter] = useState("all")
    const [quietHours, setQuietHours] = useState([moment("21:00", "HH:mm"), moment("07:00", "HH:mm")])
    const [allowEmergencyOverride, setAllowEmergencyOverride] = useState(false)

    const handleTestNotification = () => {
        showMessage("success", "Test notification sent to selected channels!")
    }

    return (
        <Card className="mb-6">
            <div className="mb-4">
                <Title level={4}>Notifications</Title>
                <Text type="secondary">Choose how often and through which channels you receive alerts.</Text>
            </div>

            <div className="mb-6">
                <Title level={5}>Delivery Frequency</Title>
                <Radio.Group onChange={(e) => setDeliveryFrequency(e.target.value)} value={deliveryFrequency}>
                    <Radio.Button value="instant">Instant</Radio.Button>
                    <Radio.Button value="hourly">Hourly Digest</Radio.Button>
                    <Radio.Button value="daily">Daily Summary</Radio.Button>
                    <Radio.Button value="weekly">Weekly Batch</Radio.Button>
                </Radio.Group>
                <Text type="secondary" className="block mt-2 text-sm">
                    Choose how frequently Radar+ sends you updates.
                </Text>
            </div>

            <div className="mb-6">
                <Title level={5}>Delivery Channels</Title>
                <Checkbox.Group onChange={setDeliveryChannels} value={deliveryChannels}>
                    <Space direction="vertical">
                        <Checkbox value="email">
                            <MailOutlined className="mr-1" /> Email
                        </Checkbox>
                        <Checkbox value="slack">
                            <MessageOutlined className="mr-1" /> Slack
                        </Checkbox>
                        <Checkbox value="in-app">
                            <BellOutlined className="mr-1" /> In-App
                        </Checkbox>
                        <Checkbox value="webhook">
                            <GlobalOutlined className="mr-1" /> Webhook (for advanced users)
                        </Checkbox>
                    </Space>
                </Checkbox.Group>
            </div>

            <div className="mb-6">
                <Title level={5}>Severity Filtering</Title>
                <Select value={severityFilter} onChange={setSeverityFilter} className="w-full md:w-64">
                    <Option value="critical">Critical only</Option>
                    <Option value="high_critical">High + Critical</Option>
                    <Option value="all">All Signals</Option>
                </Select>
            </div>

            <div className="mb-6">
                <Title level={5}>Quiet Hours</Title>
                <div className="flex items-center mb-2">
                    <Text>Do not disturb from</Text>
                    <TimePicker.RangePicker format="HH:mm" value={quietHours} onChange={setQuietHours} className="mx-2" />
                </div>
                <Checkbox checked={allowEmergencyOverride} onChange={(e) => setAllowEmergencyOverride(e.target.checked)}>
                    Allow emergency alerts to override
                </Checkbox>
            </div>

            <Button type="primary" onClick={handleTestNotification}>
                Send test notification
            </Button>
        </Card>
    )
}

export default Notifications;